import React from 'react'

export default function FutureMineralsRegionDetailsMapLoading() {
  return (
    <div className="animate-pulse">
      <div className="mb-4 flex">
        <div className="border-muted-300 flex items-center border-2">
          <div className="border-muted-300 h-20 w-20 bg-light p-2 ltr:border-r-2 rtl:border-l-2"></div>
          <div className="px-4 py-1">
            <div className="bg-muted-300 h-4 w-32 font-black" />
          </div>
        </div>
      </div>
      <div className={`border-muted-300 relative mb-4 h-full w-full border-2 bg-light p-6`}>
        <img
          style={{
            zIndex: -1,
          }}
          src={`/assets/images/region-map.webp`}
          alt={`loading map`}
        />
      </div>
    </div>
  )
}
